import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClapboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconClapboard"><Path d="M21 21H3V9H21V21Z" fill="currentColor"/><Path d="M6.82324 7H3V3H8.42285L6.82324 7Z" fill="currentColor"/><Path d="M13.4238 7H8.97656L10.5762 3H15.0234L13.4238 7Z" fill="currentColor"/><Path d="M21 7H15.5771L17.1768 3H21V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClapboard;
